module.exports = __webpack_public_path__ + "img/fz_icon.5be8fc3.png";